module.exports = __webpack_public_path__ + "static/media/Calendar.251ea605.svg";